<template>
  <section class="page-container">
    <template v-if="show">
      <!-- loading -->
      <div class="loading"
           v-if="showLoading">
        <div class="square-spin">
          <p>载入中...</p>
        </div>
      </div>
      <!-- 组件布局 -->
      <layouts ref="layout"></layouts>
      <!-- 微信分享组件 -->
      <wechat-share ref="wechatShare"
                    :options="shareInfo"></wechat-share>
      <!-- 钉钉分享组件 -->
      <ding-share ref="dingShare"
                  :options="shareInfo"></ding-share>
      <!-- 关注主办方组件 -->
      <x-follow v-if="enableFollow"></x-follow>
    </template>
    <template v-else>
      <el-empty class="forbids"
                description="找不到该页面"></el-empty>
    </template>
  </section>
</template>
<script>
import api from '@/Api'
import XFollow from '@/components/XFollow/Index.vue'
import DingShare from '@/components/XDingShare/Index.vue'
import WechatShare from '@/components/XWechatShare/Index.vue'
import Layouts from '@/components/XModules/Layouts.vue'
export default {
  /******************************************
   ** 移动渲染页面
   * @description 移动端访问页面
   * @author stone
   *****************************************/
  name: 'pageContainer',
  components: {
    Layouts,
    XFollow,
    DingShare,
    WechatShare
  },
  props: {},
  data () {
    return {
      show: true,
      showLoading: true,
      shareInfo: {
        shareImgUrl: '',
        shareTitle: '',
        shareDescription: '',
        shareLink: ''
      }
    }
  },
  computed: {
    enableFollow () {
      return this.$store.state.page.followInfo ? this.$store.state.page.followInfo.enable : false
    }
  },
  methods: {
    // 载入页面信息
    async loadPage () {
      const id = this.$route.params.id
      const res = await api.getRenderPageById(id)
      if (res) {
        this.show = true
        this.$store.state.page = res.source
        this.$nextTick(() => {
          this.showLoading = false
        })
        this.$refs.layout.startLaunch()
        document.title = res.source.webInfo.title
        document.desc = res.source.webInfo.description
        document.body.style.backgroundImage = `url(${res.source.webInfo.bgImage})`
        document.body.style.backgroundColor = res.source.webInfo.bgColor

        this.shareInfo.shareTitle = res.source.webInfo.title
        this.shareInfo.shareDescription = res.source.webInfo.description
        this.shareInfo.shareImgUrl = res.source.webInfo.shareIcon
        this.shareInfo.shareLink = window.location.href
        this.initShare()
      } else {
        this.show = false
      }
    },
    initShare () {
      // 微信初始化
      this.shareInfo.shareImgUrl = this.$store.state.page.webInfo.shareIcon
      this.shareInfo.shareTitle = this.$store.state.page.webInfo.title
      this.shareInfo.shareDescription =
        this.$store.state.page.webInfo.description
      this.shareInfo.shareLink = window.location.href
      this.$refs.wechatShare.init()
      this.$refs.dingShare.init()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadPage()
    })
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  .forbids {
    position: fixed;
    height: 100%;
    min-height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .loading {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 100%;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      font-size: 13px;
      color: rgb(83, 87, 122);
      margin-top: 20px;
      letter-spacing: 1px;
    }
  }
}
</style>
